import React, { useEffect, useRef } from "react";
import Sunburst from "sunburst-chart";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export default function SunburstChart({ elementId, data, fullScreen, borderFlag= false }) {
  const chartRef = useRef(null);
  const containerRef = useRef(null);

  const getColor = (type) => {
    switch (type) {
      case "success":
        return "#02B271";
      case "red":
        return "#FF0000";
      case "dark_orange":
        return "#ed7402";
      case "orange":
        return "#de9240";
      case "light_green":
        return "#a1e54a";
      default:
        return "white";
    }
  };

  const style = {
    mb: 1,
    fontSize: borderFlag ? '20px': '14px',
  }
  useEffect(() => {
    if (!containerRef.current) return;

    if (!chartRef.current) {
      chartRef.current = Sunburst()
        .width(300)
        .height(300)
        .sort((a, b) => b.value - a.value)
        .tooltipContent((a) => {
          return `Health Value: ${a.showValue}`;
        })
        .tooltipTitle((a) => {
          return a.name;
        })
        .centerRadius(0)
        .radiusScaleExponent(1)
        .labelOrientation("angular")
        .onClick(() => {})
        .transitionDuration(0)
        .color((d) => {
          return getColor(d.fill);
        })
        .excludeRoot(true);

      chartRef.current(containerRef.current);
    }

    chartRef.current.data({
      children: data?.graphData || [],
    });
  }, [data, fullScreen]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
      <Typography variant="body1" component={"span"} sx={{ ...style }}>
        {data?.graphLabel}
      </Typography>

      <div
        id={`${elementId}${fullScreen ? "full" : ""}`}
        ref={containerRef}
      ></div>
    </Box>
  );
}
